import React from "react";

// CSS
import "../../../css/linked-title.css";

class Title extends React.PureComponent {
    render() {
        return (
            <div className="linked-title">
                <h1>{this.props.children}</h1>
            </div>
        );
    }
}

export default Title;



// WEBPACK FOOTER //
// ./src/components/utils/titles/Title.js